var _data$product$custom$, _data$product, _data$product$custom$2, _data$product2;
/**
 * This file is used to override price display when a promo is active.
 * @see https://onnitlabs.atlassian.net/wiki/spaces/DEV/pages/3666444292/Shopify+Subscription+Discount+For+Initial+Order
 */

import PromoDiscount from './PromoDiscount';

/**
* CORE-7126
 * 30% off Subscription
 * 20% off One Time
 * All Products (including TH)
*/

/**
 * oneTimePurchasePromoSkus
 * @type {string[]}
 */
var oneTimePurchasePromoSkus = []; // Empty array = the promo will apply to all products

/**
 * subscriptionPromoSkus
 * @type {string[]}
 */
var subscriptionPromoSkus = []; // Empty array = the promo will apply to all products

var productData = document.getElementById('product-data');
var data = productData && JSON.parse(productData.textContent);
var oneTimeSavings = (_data$product$custom$ = data === null || data === void 0 || (_data$product = data.product) === null || _data$product === void 0 || (_data$product = _data$product.custom) === null || _data$product === void 0 || (_data$product = _data$product.one_time_percentage_savings) === null || _data$product === void 0 ? void 0 : _data$product.value) !== null && _data$product$custom$ !== void 0 ? _data$product$custom$ : 0;
var subscriptionSavings = (_data$product$custom$2 = data === null || data === void 0 || (_data$product2 = data.product) === null || _data$product2 === void 0 || (_data$product2 = _data$product2.custom) === null || _data$product2 === void 0 || (_data$product2 = _data$product2.subscribe_percentage_savings) === null || _data$product2 === void 0 ? void 0 : _data$product2.value) !== null && _data$product$custom$2 !== void 0 ? _data$product$custom$2 : 15;
export var promoPriceOverrides = {
  /**
      subscriptionPromo requirements:
          - An automatic discount is set in Shopify
          - OrderGroove Flex Incentive initial discount is set to 0. WARNING: If the initial discount is set to
            0 in OG, and there is no subscriptionPromo defined here, prices will not display in the buy box.
   */
  subscriptionPromo: new PromoDiscount(subscriptionPromoSkus, subscriptionSavings, 15),
  // 15 = default subscription discount

  /**
      oneTimePurchasePromo (non-subscription) requirements:
          - An automatic discount is set in Shopify
   */
  oneTimePurchasePromo: new PromoDiscount(oneTimePurchasePromoSkus, oneTimeSavings)
};